// extracted by mini-css-extract-plugin
module.exports = {"content":"DivisionPage_content__2-fOJ","img":"DivisionPage_img__3pgES"};